import Vue from 'vue';
import Router from 'vue-router';
import StarterNavbar from './layout/StarterNavbar.vue';
import StarterFooter from './layout/StarterFooter.vue';

Vue.use(Router);

const Starter = () => import('./pages/StarterPage.vue');
const InsightsPage = () => import('./pages/InsightsPage.vue');
const InsightArticlePage = () => import('./pages/InsightArticlePage.vue');

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: Starter,
        header: StarterNavbar,
        footer: StarterFooter
      }
    },
    {
      path: '/insights',
      name: 'insights',
      components: {
        default: InsightsPage,
        header: StarterNavbar,
        footer: StarterFooter
      }
    },
    {
      path: '/insights/:slug',
      name: 'insight-detail',
      components: {
        default: InsightArticlePage,
        header: StarterNavbar,
        footer: StarterFooter
      }
    }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 96 }
      };
    }

    return { x: 0, y: 0 };
  }
});

export default router;
